import React from 'react'

const ImageIcon = ({ src }) => {
  return <img src={src} className='image-icon' alt='icon' />
}
export default ImageIcon
